export default class Contact {
    constructor() {
        // Contact

        this.selectForm();
        // this.preSelectedForm();
    }

    selectForm() {
        const btns = document.querySelectorAll('.header .list [data-id]');
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    if(document.querySelector('.contact__wrapper.js-visible')) {
                        document.querySelector('.contact__wrapper.js-visible').classList.remove('js-visible');
                    }
                    if(document.querySelector('.header .list .list__item.js-selected')) {
                        document.querySelector('.header .list .list__item.js-selected').classList.remove('js-selected');
                    }
                    btn.classList.add('js-selected');
                    document.querySelector(`.contact__wrapper[data-id="${btn.dataset.id}"]`).classList.add('js-visible');
                });
            });
        }
    }

    preSelectedForm() {
        if(window.location.search) {
            const params = new URLSearchParams(document.location.search)
            const id = params.get('id');
            console.log(id);

            if(id) {
                if(document.querySelector('.contact__wrapper.js-visible')) {
                    document.querySelector('.contact__wrapper.js-visible').classList.remove('js-visible');
                }
                if(document.querySelector('.header .list .list__item.js-selected')) {
                    document.querySelector('.header .list .list__item.js-selected').classList.remove('js-selected');
                }
                document.querySelector(`.header .list .list__item[data-id="${id}"]`).classList.add('js-selected');
                document.querySelector(`.contact__wrapper[data-id="${id}"]`).classList.add('js-visible');
            }
        }
    }
}